import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/12017643-4802-44d9-bbfe-df1970a1ed6c.png"
              alt="Website Builder & SEO Logo"
              className="h-12 w-auto object-contain"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'
              }`}
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('seo-dashboard')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'
              }`}
            >
              SEO Dashboard
            </button>
            <button
              onClick={() => scrollToSection('blog')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white hover:text-[#FF6B6B]'
              }`}
            >
              Blog
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#FF6B6B] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#FF5252] transition-all whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 cursor-pointer ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#FF6B6B] py-2 cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#FF6B6B] py-2 cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#FF6B6B] py-2 cursor-pointer"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#FF6B6B] py-2 cursor-pointer"
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('seo-dashboard')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#FF6B6B] py-2 cursor-pointer"
            >
              SEO Dashboard
            </button>
            <button
              onClick={() => scrollToSection('blog')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#FF6B6B] py-2 cursor-pointer"
            >
              Blog
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-center bg-[#FF6B6B] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#FF5252] transition-all whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
